/**
 * Lobby status
 */
export var LobbyStatus;
(function (LobbyStatus) {
    LobbyStatus["WAITING"] = "WAITING";
    LobbyStatus["STARTING"] = "STARTING";
    LobbyStatus["IN_GAME"] = "IN_GAME";
    LobbyStatus["CLOSED"] = "CLOSED";
})(LobbyStatus || (LobbyStatus = {}));
//# sourceMappingURL=player.types.js.map